// Shared sustainability constants + presentational helpers.
// Extracted from SustainabilityView.jsx during Feb-2026 refactor.
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export const PALETTE = {
  s1: "#7C1D1D",
  s2: "#00334C",
  s3: "#FCEA00",
  baseline: "#94A3B8",
  emerald: "#22C55E",
  sky: "#0EA5E9",
  amber: "#F59E0B",
};

export const fmt = (n, d = 0) =>
  n == null ? "—" : Number(n).toLocaleString(undefined, { maximumFractionDigits: d });

export const fmtMoney = (n) =>
  n == null ? "—" : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export function KPI({ label, value, hint, icon: Icon, tone = "default", testId }) {
  const tones = {
    default: "text-slate-900",
    good:    "text-emerald-700",
    warn:    "text-amber-700",
    danger:  "text-rose-700",
    brand:   "text-emerald-800",
  };
  return (
    <div data-testid={testId} className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-start justify-between">
        <div className="text-[11px] uppercase tracking-wide text-slate-500">{label}</div>
        {Icon && <Icon className="w-3.5 h-3.5 text-slate-400" />}
      </div>
      <div className={`mt-1 font-display text-2xl ${tones[tone]}`}>{value}</div>
      {hint && <div className="text-xs text-slate-500 mt-0.5">{hint}</div>}
    </div>
  );
}

export function YoyBadge({ current, baseline }) {
  if (!baseline) return null;
  const pct = ((current - baseline) / baseline) * 100;
  const better = pct < 0;
  const Icon = better ? ArrowDownRight : ArrowUpRight;
  const cls = better ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                     : "bg-rose-50 text-rose-700 border-rose-200";
  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 rounded border text-xs font-medium ${cls}`}>
      <Icon className="w-3 h-3" />
      {pct >= 0 ? "+" : ""}{pct.toFixed(1)}% vs baseline
    </div>
  );
}
